export default __webpack_public_path__ + "static/Edita_Prima_photo_bg_news_page-0c059199ee848becc8607e80fc251291.jpg";